// Section : Features
// Style : Four Columns Features Section

// import node module libraries
import { useEffect, useState } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import axios from 'axios';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// import custom components
import PlanPricingTable from 'components/marketing/common/pricing/PlanPricingTable';

// import media files
import StartIcon from 'assets/images/svg/price-icon-1.svg';
import IndividualIcon from 'assets/images/svg/price-icon-2.svg';
import TeamIcon from 'assets/images/svg/price-icon-3.svg';

const PricingPlans = () => {
	const title = 'Prices & Plans';
	const description = `Choose the package that's right for you and save money with annual payment.`;
	
	const [plansData, setPlansData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};
	
	const getPlansData = async () => {
		setIsLoading(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/plans?type=platform`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setPlansData(responseData);
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	}

	useEffect(() => {
		getPlansData();
	}, []);

	return (
		<section className="py-lg-18 py-10 bg-primary">
			<Container>
				<PlanPricingTable
					title={title}
					description={description}
					plans={plansData}
					isLoading={isLoading}
				/>
			</Container>
		</section>
	);
};

export default PricingPlans;
